import _ from 'lodash';

export const joinStrings = (delimiter: string, ...texts: string[]): string => {
  return texts.filter(t => !_.isEmpty(t)).join(delimiter);
}

export const countCharacters = (char: string, string: string) =>  {
  return string.split('').reduce((acc, ch) => ch === char ? acc + 1: acc, 0)
};
